var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00AECB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.344,393.376V0h-293.92L2.344,104.64V512h416v-73.376l68.688,68.688l22.624-22.624L418.344,393.376z M114.344,50.784 V96h-52.8L114.344,50.784z M386.344,361.376l-40.72-40.72C385.998,267.787,375.869,192.2,323,151.826 c-52.869-40.374-128.456-30.245-168.83,22.624c-40.374,52.869-30.245,128.456,22.624,168.83 c43.162,32.961,103.044,32.961,146.206,0l63.344,63.344V480h-352V128h112V32h240V361.376z M338.344,248c0,48.601-39.399,88-88,88 s-88-39.399-88-88c0-48.601,39.399-88,88-88C298.923,160.053,338.291,199.421,338.344,248z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.344,
    y: 416,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.344,
    y: 416,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.344,
    y: 416,
    width: 32,
    height: 32
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFind);
export default __webpack_public_path__ + "static/media/icon-find.09a7c8dd642fadcde058144cda092cbf.svg";
export { ForwardRef as ReactComponent };